import { jwtDecode } from "jwt-decode";
import { FiPhoneCall } from "react-icons/fi";
import { SiGooglemeet } from "react-icons/si";
import {
  MdOutlineMailOutline,
  MdOutlineNoteAlt,
  MdOutlinePeopleAlt,
} from "react-icons/md";
import { RiUserFollowLine } from "react-icons/ri";
import { IoLogoWhatsapp } from "react-icons/io5";
import { RxActivityLog } from "react-icons/rx";
import { GrDocumentPpt } from "react-icons/gr";
import {
  FaFaceFrown,
  FaFaceFrownOpen,
  FaFaceGrinStars,
  FaFaceMeh,
  FaFaceSmile,
} from "react-icons/fa6";

export const checkIfAuthenticated = () => {
  const token = localStorage.getItem("token");

  try {
    const decodedToken = jwtDecode(token);

    const tokenExpirationDate = new Date(decodedToken.exp) * 1000;
    const currentDate = new Date();

    return tokenExpirationDate > currentDate;
  } catch (error) {
    return false;
  }
};

export const saveUserInWindow = () => {
  const token = localStorage.getItem("token");
  const decodedToken = jwtDecode(token);
  window.user = decodedToken;
};

// Dias restantes até a data (inclusive o dia de hoje).
//
// Usava moment só para este cálculo — e como `utils.js` é importado pelo
// Sidebar, que é carregado em toda visita, a biblioteca inteira com todos os
// locales ia parar no bundle principal por causa de uma subtração.
//
// `Math.trunc` reproduz o `absFloor` que o moment aplica em diff("days"):
// verificado contra o próprio moment em 7 casos, incluindo diferenças
// negativas e viradas de dia.
export const calculateExpirationPeriodTest = (date) => {
  const expiration = new Date(date).getTime();
  const today = Date.now();
  if (Number.isNaN(expiration)) return NaN;
  return Math.trunc((expiration - today) / 86400000) + 1;
};

export const getFirstLettersName = (fullName) => {
  const nameParts = fullName.trim().split(" ");

  const firstLetterFirstName = nameParts[0][0];
  const firstLetterLastName =
    nameParts.length > 1 ? nameParts[nameParts.length - 1][0] : "";

  return `${firstLetterFirstName}${firstLetterLastName}`.toUpperCase();
};

export const isValidCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/[^\d]+/g, "");
  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(0))) return false;
  tamanho += 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  return resultado === parseInt(digitos.charAt(1));
};

export const isValidCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, "");
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
  let soma = 0;
  let resto;
  for (let i = 1; i <= 9; i++)
    soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++)
    soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;
  return true;
};

export const formatToReal = (valor) => {
  if (typeof valor === "number") {
    valor = valor.toString();
  }

  if (typeof valor !== "string") return "R$ -";

  valor = valor.replace(/[^\d.,]/g, "").trim();

  let numero;

  if (valor.includes(",") && valor.includes(".")) {
    const tratado = valor.replace(/\./g, "").replace(",", ".");
    numero = parseFloat(tratado);
  } else if (valor.includes(",")) {
    numero = parseFloat(valor.replace(",", "."));
  } else {
    numero = parseFloat(valor);
  }

  if (isNaN(numero)) return "R$ -";

  return numero.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

export const resetValuesForm = (values, setValue, reset) => {
  values.forEach((value) => {
    setValue(value, "");
  });
  reset();
};

export const uploadPDF = async (component, info, queryId) => {
  // Import dinâmico: pdf-lib + dom-to-image são pesados e `utils.js` é
  // importado pelo Sidebar (bundle inicial).
  const { handleDownloadPdf } = await import("./pdf-exporter");
  const file = await handleDownloadPdf(component.current);
  localStorage.setItem("pdfFile", file);
  return file;
};

export const formatCPF_CNPJ = (document) => {
  const docLimpo = document.replace(/\D/g, "");

  if (docLimpo.length < 4) {
    return "Documento inválido";
  }

  const inicio = docLimpo.slice(0, 3);
  const fim = docLimpo.slice(-1);

  const oculto = "*".repeat(docLimpo.length - 4);

  return `${inicio}${oculto}${fim}`;
};

export const getImageURLScore = (score) => {
  const scoreImages = [
    "/assets/score/score_1.png",
    "/assets/score/score_2.png",
    "/assets/score/score_3.png",
    "/assets/score/score_4.png",
    "/assets/score/score_5.png",
    "/assets/score/score_6.png",
    "/assets/score/score_7.png",
    "/assets/score/score_8.png",
    "/assets/score/score_9.png",
    "/assets/score/score_10.png",
    "/assets/score/score_11.png",
    "/assets/score/score_12.png",
    "/assets/score/score_13.png",
    "/assets/score/score_14.png",
    "/assets/score/score_15.png",
  ];

  const interval = 1000 / scoreImages.length;
  const index = Math.min(Math.floor(score / interval), scoreImages.length - 1);

  return scoreImages[index];
};

export const getColorScore = (score) => {
  const colors = ["#ed505b", "#FF9700", "#f2da09", "#39EA0E", "#027B01"];

  if (score < 0) score = 0;
  if (score > 1000) score = 1000;

  const index = Math.floor(score / 200);

  return colors[index];
};

export const getColorProbability = (probability) => {
  const colors = ["#027B01", "#f2da09", "#F43240"];

  if (probability < 0) probability = 0;
  if (probability > 1000) probability = 100;

  const index = Math.floor(probability / 33);

  return colors[index];
};

export const getLetterScore = (score) => {
  const letter = ["D", "C", "B", "AA", "AAA"];

  if (score < 0) score = 0;
  if (score > 1000) score = 100;

  const index = Math.floor(score / 200);

  return letter[index];
};

export const maskCEP = (cep) => {
  cep = cep?.replace(/\D/g, "");
  cep = cep?.replace(/^(\d{5})(\d)/, "$1-$2");

  return cep;
};

export const maskStateSubscription = (inscricao) => {
  inscricao = inscricao.replace(/\D/g, "");
  return inscricao.replace(
    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    "$1.$2.$3.$4-$5"
  );
};

export const getImageScoreSale = (score) => {
  let scoreLetter;

  if (score <= 125) {
    scoreLetter = "1";
  } else if (score <= 250) {
    scoreLetter = "2";
  } else if (score <= 375) {
    scoreLetter = "3";
  } else if (score <= 500) {
    scoreLetter = "4";
  } else if (score <= 625) {
    scoreLetter = "5";
  } else if (score <= 750) {
    scoreLetter = "6";
  } else if (score <= 875) {
    scoreLetter = "7";
  } else {
    scoreLetter = "8";
  }

  return `/assets/score/score_${scoreLetter}.png`;
};

export const calculateRiskScore = (
  pendencias,
  protestos,
  score,
  probabilidade
) => {
  let maxScore = 1000;
  const pesoPendencias = 25;
  const pesoProtestos = 25;

  if (score > 800) {
    maxScore = 850;
  } else if (score > 600) {
    maxScore = 650;
  } else if (score > 400) {
    maxScore = 500;
  } else {
    maxScore = 300;
  }

  if (probabilidade / 100 > 85) {
    maxScore -= 100;
  }

  if (pendencias > 0 || protestos > 0) {
    const penalidade = pendencias * pesoPendencias + protestos * pesoProtestos;

    return Math.max(0, maxScore - penalidade);
  }

  return Math.max(0, maxScore);
};

export const formatDateToYY = (input) => {
  const match = input.match(/^([A-Za-z]{3})\/(\d{4})$/);

  if (match) {
    const month = match[1]; // Mês (MMM)
    const day = match[2].slice(0, 2); // Extrai os primeiros dois dígitos do dia

    return `${month}/${day}`;
  } else {
    return input; // Retorna a string original caso o formato não seja esperado
  }
};

export const formatDateToDDMM = (dateString) => {
  const month = dateString.slice(0, 2);
  const year = dateString.slice(2);

  const shortYear = year.slice(-2);

  return `${month}/${shortYear}`;
};

export const normalizeText = (text) => {
  return text
    .normalize("NFD") // Decompõe caracteres acentuados
    .replace(/[\u0300-\u036f]/g, "") // Remove acentos
    .replace(/ç/g, "c") // Substitui 'ç' por 'c'
    .replace(/\s+/g, "-") // Substitui espaços por '-'
    .replace(/[^a-zA-Z0-9-]/g, "") // Remove tudo que não for letra, número ou '-'
    .toLowerCase(); // Converte para minúsculas
};

export const formatDocument = (valor) => {
  if (!valor) return "";

  let numeros = `${valor}`?.replace(/\D/g, "");

  if (numeros.length <= 11) {
    numeros = numeros?.padStart(11, "0"); // completa CPF com zeros
    return numeros
      ?.replace(/^(\d{3})(\d)/, "$1.$2")
      ?.replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      ?.replace(/\.(\d{3})(\d)/, ".$1-$2");
  } else {
    numeros = numeros.padStart(14, "0"); // completa CNPJ com zeros
    return numeros
      ?.replace(/^(\d{2})(\d)/, "$1.$2")
      ?.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      ?.replace(/\.(\d{3})(\d)/, ".$1/$2")
      ?.replace(/(\d{4})(\d)/, "$1-$2");
  }
};

export const fmt = {
  date: (v) => (v ? new Date(v).toLocaleDateString() : "—"),
  currency: (v) =>
    typeof v === "number"
      ? v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
      : "—",
  checkbox: (v) => (v ? "Sim" : "Não"),
  default: (v) => (v === null || v === undefined || v === "" ? "—" : String(v)),
};

export function formatAnswer(field, val) {
  if (field.type === "currency") return fmt.currency(val);
  if (field.type === "date") return fmt.date(val);
  if (field.type === "checkbox") return fmt.checkbox(val);
  return fmt.default(val);
}

export function hasHtmlTags(s = "") {
  return /<\/?[a-z][\s\S]*>/i.test(s);
}
export function escapeHtml(s = "") {
  return s
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}
/** Converte texto simples em HTML “bonitinho” (parágrafos e <br>) */
export function toRichHtml(htmlOrText = "") {
  const src = String(htmlOrText || "");
  if (!src.trim()) return "";
  if (hasHtmlTags(src)) return src; // já é HTML do TipTap
  // texto puro -> <p>…</p> com quebras
  const parts = src
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean);
  if (!parts.length) return "";
  return parts
    .map((p) => `<p>${escapeHtml(p).replace(/\n/g, "<br>")}</p>`)
    .join("");
}
/** Remove “HTML visualmente vazio” do TipTap */
export function stripVisualEmpty(html = "") {
  return html.replace(/^(\s|<p><br><\/p>|<p>\s*<\/p>)+$/gi, "").trim();
}

export function fmtBR(d) {
  if (!d) return "—";
  try {
    const date = new Date(d);
    return date.toLocaleDateString("pt-BR");
  } catch {
    return "—";
  }
}

export function buildLocalISO(dateStr, timeStr) {
  if (!dateStr && !timeStr) return null;
  const [y, m, d] = (dateStr || "").split("-").map(Number);
  const [hh = 0, mm = 0] = (timeStr || "").split(":").map(Number);
  if (!y || !m || !d) return null;
  const dt = new Date(y, m - 1, d, hh, mm, 0, 0);
  return dt.toISOString();
}

export function prettySize(bytes) {
  if (!bytes && bytes !== 0) return "";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let i = 0,
    n = Math.max(bytes, 0);
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i++;
  }
  return `${n.toFixed(n >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
}

export function fileIconFor(mime = "", name = "") {
  const ext = (name.split(".").pop() || "").toLowerCase();
  if (mime.startsWith("image/")) return "🖼️";
  if (mime === "application/pdf" || ext === "pdf") return "📄";
  if (mime.includes("sheet") || ["xls", "xlsx", "csv"].includes(ext))
    return "📊";
  if (mime.includes("presentation") || ["ppt", "pptx", "key"].includes(ext))
    return "🖥️";
  if (
    mime.includes("word") ||
    ["doc", "docx", "rtf", "odt", "txt", "md"].includes(ext)
  )
    return "📝";
  if (mime.startsWith("audio/")) return "🎵";
  if (mime.startsWith("video/")) return "🎬";
  if (["zip", "rar", "7z", "gz", "tar"].includes(ext)) return "🗜️";
  return "📎";
}

export function invalidateStats(cardId) {
  try {
    const bus = window.__CRM_STATS_BUS__;
    if (bus) {
      bus.dispatchEvent(
        new CustomEvent("invalidate", {
          detail: { cardId: cardId ? String(cardId) : "*" },
        })
      );
    }
  } catch {}
}

export function dateToHHMM(d) {
  if (!(d instanceof Date) || isNaN(d)) return "";
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${hh}:${mm}`;
}

// Formats how long after the due date a task was completed, e.g. "2h",
// "1d 3h", "15min". Returns "" when there's no delay (or missing dates),
// so callers can safely append it to an existing "(atrasada)" label.
export function formatLateDuration(completedAt, dueDate) {
  if (!completedAt || !dueDate) return "";
  const diffMs = new Date(completedAt) - new Date(dueDate);
  if (!Number.isFinite(diffMs) || diffMs <= 0) return "";

  const totalMinutes = Math.floor(diffMs / 60000);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;

  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  // Minutes only matter for short delays — once it's already days late,
  // showing "1d 3h 12min" is just noise.
  if (minutes > 0 && days === 0) parts.push(`${minutes}min`);
  if (!parts.length) parts.push("menos de 1min");

  return parts.join(" ");
}

export const labelMap = {
  ligacao: "Ligação",
  reuniao: "Reunião",
  email: "E-mail",
  visita: "Visita",
  followup: "Follow-up",
  whatsapp: "WhatsApp",
  proposta: "Proposta",
};

export const labelIcon = (label) => {
  switch (label) {
    case "ligacao":
      return <FiPhoneCall className="text-blue-600" fontSize={16} />;
    case "reuniao":
      return <SiGooglemeet className="text-green-600" fontSize={16} />;
    case "email":
      return <MdOutlineMailOutline className="text-orange-500" fontSize={16} />;
    case "visita":
      return <MdOutlinePeopleAlt className="text-cyan-600" fontSize={16} />;
    case "followup":
      return <RiUserFollowLine className="text-purple-600" fontSize={16} />;
    case "whatsapp":
      return <IoLogoWhatsapp className="text-green-600" fontSize={16} />;
    case "nota":
      return <MdOutlineNoteAlt className="text-green-600" fontSize={16} />;
    case "proposta":
      return <GrDocumentPpt className="text-green-600" fontSize={16} />;
    default:
      return <RxActivityLog />;
  }
};

export const iconsEmoji = {
  1: FaFaceFrownOpen,
  2: FaFaceFrown,
  3: FaFaceMeh,
  4: FaFaceSmile,
  5: FaFaceGrinStars,
};

export const textEmoji = {
  1: "Ruim",
  2: "Precisa melhorar",
  3: "Regular",
  4: "Bom",
  5: "Excelente",
};

export const colorEmoji = {
  1: "text-red-600",
  2: "text-orange-500",
  3: "text-yellow-500",
  4: "text-green-500",
  5: "text-green-700",
};

/**
 * Cor de TEXTO para uma etiqueta colorida (tag.color, hex escolhido pelo usuário).
 * No tema claro devolve a própria cor (sem mudança). No escuro, cores escuras
 * (#111827, #6b7280…) sumiriam sobre o cartão escuro: clareia misturando com o
 * texto do tema (#F4F2F8) até ficar legível. Valores que não são #rrggbb passam direto.
 */
// Tema claro: a cor da etiqueta serve de texto sobre o próprio tom a ~13% no
// branco (chips). Cores médias (azul, verde, laranja claros) davam 2–3:1; aqui
// a cor escurece (mistura com preto) até chegar a 4,5:1 contra esse fundo.
const darkenTagTextForLight = (color) => {
  const match = color.trim().match(/^#([0-9a-f]{6})$/i);
  if (!match) return color;
  const base = [0, 2, 4].map((i) => parseInt(match[1].slice(i, i + 2), 16));
  const toLinear = (v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  const lum = (rgb) =>
    0.2126 * toLinear(rgb[0]) +
    0.7152 * toLinear(rgb[1]) +
    0.0722 * toLinear(rgb[2]);
  const ratio = (a, b) => {
    const [hi, lo] = lum(a) >= lum(b) ? [a, b] : [b, a];
    return (lum(hi) + 0.05) / (lum(lo) + 0.05);
  };
  const tint = base.map((v) => v * 0.13 + 255 * 0.87);
  let text = base;
  for (let t = 0; t <= 1 && ratio(text, tint) < 4.5; t += 0.07) {
    text = base.map((v) => v * (1 - t));
  }
  if (text === base) return color;
  return `#${text
    .map((v) => Math.round(v).toString(16).padStart(2, "0"))
    .join("")}`;
};

export const readableTagTextColor = (color, isDark) => {
  if (typeof color !== "string") return color;
  if (!isDark) return darkenTagTextForLight(color);
  const match = color.trim().match(/^#([0-9a-f]{6})$/i);
  if (!match) return color;
  const hex = match[1];
  const channels = [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16));
  const toLinear = (v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  const luminance =
    0.2126 * toLinear(channels[0]) +
    0.7152 * toLinear(channels[1]) +
    0.0722 * toLinear(channels[2]);
  if (luminance >= 0.3) return color;
  const target = [238, 238, 238];
  const mixed = channels.map((v, i) => Math.round(v * 0.35 + target[i] * 0.65));
  return `#${mixed.map((v) => v.toString(16).padStart(2, "0")).join("")}`;
};
